exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-c856684c]{width:100%;height:90px;line-height:50px;overflow:hidden}.active[data-v-c856684c]{overflow:visible;height:auto}li[data-v-c856684c]{width:80vw;word-break:break-all}li[data-v-c856684c],span[data-v-c856684c]{font-size:14px;line-height:30px}span[data-v-c856684c]{display:inline-block;margin-left:10px;color:#000}.rotate[data-v-c856684c]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
